$( document ).ready(function() {
    $('#feed-total').text('0');
    $('#feed-percentage').text('0%');
    $('#feed-ration').text('0 / ');
    $('#elements-size').text('0');
});

window.calc_percentaje_feed = function() {
    var totalKg = 0.0;
    var totalItems = parseFloat( $('#elements-size').text());

    $('.feed_foot_values').each(function(index) {if($(this).val()){ totalKg += parseFloat($(this).val());}});

    $('#feed-total').text(totalKg);

    if (totalItems > 0) {
        $('#feed-percentage').text('100%');
        $('#feed-ration').text(totalKg + " / ");
        $('.feed_foot_values').each(function(index) {
            if($(this).val()){
                var percentage = ((parseFloat($(this).val()) * 100) / totalKg).toFixed(1);
                var objects = $('.feed_foot_percentage').each(function(index) { this });
                var element_id = $(objects[index]).attr('id');
                $('#'+element_id).val(percentage + '%');
            }
        });
    }else{
        $('#feed-percentage').text('0%')
        $('#feed-ration').text('0 / ');
    }
}